<template>
	<v-layout 
		row 
		wrap 
		newbackground 
		class="form-step-three"
		:class="{'quinti':isQinti, 'lucky': isLucky }">
		<div class="loading" v-if="loadingLocation || loadingRegister">
			<div class="sk-circle">
				<div class="sk-circle1 sk-child"></div>
				<div class="sk-circle2 sk-child"></div>
				<div class="sk-circle3 sk-child"></div>
				<div class="sk-circle4 sk-child"></div>
				<div class="sk-circle5 sk-child"></div>
				<div class="sk-circle6 sk-child"></div>
				<div class="sk-circle7 sk-child"></div>
				<div class="sk-circle8 sk-child"></div>
				<div class="sk-circle9 sk-child"></div>
				<div class="sk-circle10 sk-child"></div>
				<div class="sk-circle11 sk-child"></div>
				<div class="sk-circle12 sk-child"></div>
			</div>
			<div class="sk-text" v-if="loadingRegister">SE ESTÁ CREANDO SU COMERCIO</div>
		</div>
		<div class="wrapper-message" v-if="messageBd">
			<div class="wrapper-message-buttons">
				<v-layout wrap justify-space-around>
					<v-flex xs12>
						<p class="wrapper-message-text">Desea replicar productos de nuestra base de datos</p>
					</v-flex>
					<v-flex xs4>
						<button 
							class="wrapper-message-btn btn-orange"
							:class="{ 'btn-lucky': isLucky }"
							@click="$emit('selection-option', 'si')">SI</button>
					</v-flex>
					<v-flex xs4>
						<button 
							class="wrapper-message-btn"
							:class="{ 'btn-lucky-no': isLucky }"
							@click="$emit('selection-option', 'no')">NO</button>
					</v-flex>
				</v-layout>
			</div>
		</div>
		<v-flex xs12 class="form-step-three-body">
			<div v-if="locationInactive">
				<v-btn
					class="form-btn-close"
					depressed
					flat
					icon
					@click="$emit('close-form')"
					v-if="!isForm"
				>
					<v-icon color="primary">close</v-icon>
				</v-btn>
				<v-btn
					class="form-btn-back mx-0"
					:color="isQinti ? 'blue darken-4' : isLucky ? 'backL' : 'primary'"
					depressed
					flat
					@click="$emit('back-step')"
				>
					<v-icon size="18">arrow_back_ios</v-icon> <span class="caption">Atrás</span>
				</v-btn>
				<div v-if="locationInactive" class="form-step-three-input">
					<app-input
						class="form-step-three-column form-step-three-white"
						label="Nombre de tu negocio"
						model="commerceName"
						:value="form.commerceName"
						@input="$emit('get-data', $event)"
					></app-input>
				</div>
			</div>
			<div v-else>
				<v-layout 
					class="form-step-three-text"
					:class="[ isQinti ? 'pink darken-1' : isLucky ? 'backL' : 'primary']">
					<v-flex xs2>
						<v-btn
							color="white"
							depressed
							flat
							icon
							@click="$emit('back-step')"
							class="btn-information"
						>
							<v-icon color="white">arrow_back_ios</v-icon>
						</v-btn>
					</v-flex>
					<v-flex xs8 class="w-semibold white--text text-xs-left wrapper-infomation">
						<v-layout>
							<v-flex xs6 class="border-r">
								<p class="mb-0">{{ labelEntry }}</p>
							</v-flex>
							<v-flex xs6 pl-2>
								<p class="mb-0">Negocio</p>
								<p>{{ form.commerceName }}</p>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs2>
						<v-btn
							depressed
							flat
							icon
							@click="$emit('close-form')"
							v-if="!isForm"
							class="btn-information"
						>
							<v-icon color="white">close</v-icon>
						</v-btn>
					</v-flex>
			</v-layout>
			</div>
		</v-flex>
		<v-flex xs12>
			<v-layout row wrap align-center class="form-step-three-header">
				<v-flex xs12 class="form-step-three-column">
					<template v-if="locationInactive">
						<v-btn
							:disabled="!form.commerceName"
							class="btn-location"
							:color="isQinti ? 'pink darken-1' : isLucky ? 'succesL' : 'orange'"
							@click="$emit('active-location')"
						>
							Haz clic aquí y usa tu ubicación
						</v-btn>
					</template>
					<template v-else>
						<v-layout 
							align-center 
							row 
							wrap 
							class="form-step-three-result"
							:class="{ 'qinti': isQinti }">
							<v-flex xs2>
								<img
									src="/static/images-new/icons/icon-location-on.svg"
									alt="ubicación"
									height="25"
								/>
							</v-flex>
							<v-flex xs8 text-xs-left>
								<p class="mb-0 location-text">Ubicación</p>
								<p class="mb-0 location-label">
									{{ exactLocation }}
								</p>
							</v-flex>
							<v-flex xs2>
								<v-btn
									class="ma-0"
									depressed
									flat
									icon
									@click="$emit('erase-location')"
								>
									<img
										src="/static/images-new/icons/icon-config-location-orange.svg"
										alt="configurar ubicación"
										height="26"
									/>
								</v-btn>
							</v-flex>
						</v-layout>
					</template>
				</v-flex>
				<v-flex xs12 class="form-step-three-column">
					<v-text-field
						v-if="locationInactive"
						prepend-icon="location_on"
						class="input-location pl-2"
						:class="{ 'qinti': isQinti }"
						hide-details
						id="input-autocomplete"
						placeholder="Buscar dirección"
						:disabled="!form.commerceName"
						v-model="address"
						@input="$emit('get-address', $event)"
					></v-text-field>
					<v-text-field
						v-else
						class="input-location pl-2"
						hide-details
						prepend-icon="location_on"
						:placeholder="countryCode === 'PE' ? 'Escribir dirección exacta' : 'Escribe referencia, conjunto, nro. de casa'"
						:value="form.address"
						@input="$emit('get-data', { model: 'address', value: $event })"
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 class="form-step-three-map">
			<template v-if="locationInactive">
				<!-- <map-view :url-image="mapImage"></map-view> -->
				<form-message />
			</template>
			<template>
				<img
					class="marker-icon"
					src="/static/images-new/icons/icon-location-marker.png"
					alt="marcador mapa"
					v-if="!locationInactive"
				/>
				<gmap-component
					v-show="!locationInactive"
					:center="center"
					:height="height"
					:markers="markers"
					:styles="styles"
					width="100%"
					:zoom="zoom"
					@on-center-changed="$emit('on-center-changed', $event)"
				></gmap-component>
			</template>
		</v-flex>
	</v-layout>
</template>

<script>
	import appInput from '@/components/home/form/app-input';
	import formSimulator from '@/components/simulator/form-simulator';
	import gmapComponent from '@/components/shared/gmap-component';
	import mapView from '@/components/market-place/map-view';
	import formMessage from '@/components/simulator/form-message';

	function created() {
		this.loadLocations();
	}

	function loadLocations() {
		const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
		const params = {
			center: `${this.latitude},${this.longitude}`,
			format: 'png',
			key: process.env.GOOGLE_MAP_KEY,
			maptype: 'roadmap',
			saturation: -100,
			scale: false,
			size: `350x${this.heightStatic}`,
			visualRefresh: true,
			zoom: 15,
		};
		this.mapImage = `${baseUrl}?center=${params.center}&maptype=${params.maptype}&size=${params.size}&zoom=${params.zoom}&key=${params.key}&scale=${params.scale}&format=${params.format}&style=saturation:${params.saturation}&visual_refresh=${params.visualRefresh}`;
	}

	function labelEntry() {
		const index = this.items.findIndex(i => i.id === this.form.itemId);
		if (index > -1) {
			return this.items[index].name;
		}
		return 'Rubro';
	}

	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	function data() {
		return {
			address: '',
			mapImage: '',
			styles: [
				{
					elementType: 'geometry',
					stylers: [
						{
							color: '#f5f5f5',
						},
					],
				},
				{
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#616161',
						},
					],
				},
				{
					elementType: 'labels.text.stroke',
					stylers: [
						{
							color: '#f5f5f5',
						},
					],
				},
				{
					featureType: 'administrative.land_parcel',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#bdbdbd',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'geometry',
					stylers: [
						{
							color: '#eeeeee',
						},
					],
				},
				{
					featureType: 'poi',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#757575',
						},
					],
				},
				{
					featureType: 'poi.park',
					elementType: 'geometry',
					stylers: [
						{
							color: '#e5e5e5',
						},
					],
				},
				{
					featureType: 'poi.park',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#9e9e9e',
						},
					],
				},
				{
					featureType: 'road',
					elementType: 'geometry',
					stylers: [
						{
							color: '#ffffff',
						},
					],
				},
				{
					featureType: 'road.arterial',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#757575',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'geometry',
					stylers: [
						{
							color: '#dadada',
						},
					],
				},
				{
					featureType: 'road.highway',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#616161',
						},
					],
				},
				{
					featureType: 'road.local',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#9e9e9e',
						},
					],
				},
				{
					featureType: 'transit.line',
					elementType: 'geometry',
					stylers: [
						{
							color: '#e5e5e5',
						},
					],
				},
				{
					featureType: 'transit.station',
					elementType: 'geometry',
					stylers: [
						{
							color: '#eeeeee',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'geometry',
					stylers: [
						{
							color: '#c9c9c9',
						},
					],
				},
				{
					featureType: 'water',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#9e9e9e',
						},
					],
				},
			],
		};
	}

	export default {
		name: 'form-step-three',
		components: {
			appInput,
			formSimulator,
			gmapComponent,
			mapView,
			formMessage,
		},
		computed: {
			labelEntry,
			isQinti,
			isLucky,
		},
		created,
		data,
		methods: {
			loadLocations,
		},
		props: {
			center: {
				default: () => {},
				type: Object,
			},
			countryCode: String,
			exactLocation: String,
			form: {
				default: () => {},
				type: Object,
			},
			height: {
				default: '406',
				type: [Number, String],
			},
			heightStatic: {
				default: '406',
				type: [Number, String],
			},
			latitude: [Number, String],
			loadingLocation: {
				default: false,
				type: Boolean,
			},
			locationInactive: {
				default: true,
				type: Boolean,
			},
			longitude: [Number, String],
			markers: {
				default: () => [],
				type: Array,
			},
			zoom: [Number, String],
			items: {
				default: () => [],
				type: Array,
			},
			loadingRegister: {
				default: false,
				type: Boolean,
			},
			messageBd: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.form-step-three {
		height: 91%;
		left: 17px;
		position: absolute;
		top: 19px;
		width: 91%;

		&-title {
			font-size: size(large27);
			letter-spacing: normal;
			line-height: normal;
			padding-left: 20px;
			text-align: left;
		}

		&-body {
			background-color: color(stepbackground);
			padding: 0px;
			position: relative;
		}

		&-column {
			position: relative;
			z-index: 1;
		}

		&-map {
			padding-bottom: 54px;
			position: relative;
		}

		&-commerce-name {
			color: color(primary);
		}

		&-label {
			color: white;
			font-size: 10px;
			color: color(secondary);
		}

		&-text {
			padding: 30px 0 12px;
		}

		&-input {
			background-color: color(warning);
			color: color(white) !important;
			margin-top: 40px;
			padding: 5px 19px 20px 19px;
		}

		&-result {
			background: color(green-l);
			padding: 4px;
			width: 99%;
		}

		&.quinti {
			.form-step-three-input {
				background-color: #ede35c;
			}

			.form-step-three-result {
				background: none;
			}
		}

		&.lucky {
			.form-step-three-input {
				background-color: map-get($colors, back-geo-l);
			}

			.form-step-three-result {
				background: none;
			}
		}
	}

	.btn-location {
		border-radius: 5px !important;
		color: color(white);
		font-size: size(medium16);
		font-weight: weight(black);
		height: 50px;
		width: 315px;
	}

	.input-location {
		border: 1px solid color(newprimary);
		border-radius: 4px;
		height: 48px;
		margin: 6px auto 0px;
		padding-top: 0px;
		width: 315px;
	}

	.map-view, .form-message {
		height: calc(100vh - 290px) !important;
		position: relative !important;
		top: auto !important;

		@media (min-width: 936px) {
			height: calc(100vh - 257px) !important;
		}
	}

	.location {
		&-text {
			color: color(newsecondary);
			font-size: size(medium);
		}

		&-label {
			color: color(primary);
			font-size: size(medium);
			font-weight: weight(semibold);
		}
	}

	.vue-map-container {
		z-index: 1;
	}

	.show-form {
		.form-step-three {
			height: 100%;
			left: 0px;
			top: 0px;
			width: 100%;
		}

		.btn-location,
		.input-location {
			width: 300px;
		}

		.map-view, .form-message {
			height: calc(100vh - 289px) !important;

			@media (min-width: 936px) {
				height: calc(100vh - 327px) !important;
			}
		}
	}

	.marker-icon {
		bottom: 54px;
		left: 0;
		margin: auto;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 2;
	}
	
	.border-right-green {
		border-right: 2px solid color(primary);
	}

	.wrapper-infomation {
		border: 1px solid color(white);
		font-size: 13px;
		height: 65px;
		padding: 5px;
	}

	.border-r {
		border-right: 1px solid color(white);
	}

	.btn-information {
		z-index: 1;
	}

	.wrapper-message {
		background: rgba(0, 0, 0, .6);
		bottom: 0;
		display: flex;
		flex-direction: column;
    justify-content: center;
		height: 100%;
		left: 0;
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
		z-index: 3;

		&-buttons {
			color: map-get($colors, white);
			width: 100%;
		}

		&-text {
			font-size: 22px;
    	font-weight: 700;
		}

		&-btn {
			background: map-get($colors, darkenprimary);
			border-radius: 4px;
			padding: 10px 0;
			width: 100%;
		}

		.btn-orange {
			background: map-get($colors, newprimary);
		}

		.btn-lucky {
			background: map-get($colors, back-l) !important;
		}

		.btn-lucky-no {
			background: map-get($colors, succes-l) !important;
		}
	}
	
	// Componente loading

	.loading {
		background: rgba(0, 0, 0, .5);
		height: 100%;
		position: absolute;
		width: 100%;
		z-index: 3;
	}

	.sk-circle {
		bottom: 0px;
		height: 40px;
		left: 0px;
		margin: auto;
		position: absolute;
		right: 0px;
		top: 0px;
		width: 40px;
	}

	.sk-circle .sk-child {
		height: 100%;
		left: 0;
		position: absolute;
		top: 0;
		width: 100%;
	}

	.sk-circle .sk-child:before {
		background-color: color(white);
		border-radius: 100%;
		content: '';
		display: block;
		height: 28%;
		margin: -12px auto;
		width: 28%;
		-webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
				animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
	}

	.sk-circle .sk-circle2 {
		-webkit-transform: rotate(30deg);
			-ms-transform: rotate(30deg);
				transform: rotate(30deg);
	}

	.sk-circle .sk-circle3 {
		-webkit-transform: rotate(60deg);
			-ms-transform: rotate(60deg);
				transform: rotate(60deg);
	}

	.sk-circle .sk-circle4 {
		-webkit-transform: rotate(90deg);
			-ms-transform: rotate(90deg);
				transform: rotate(90deg);
	}

	.sk-circle .sk-circle5 {
		-webkit-transform: rotate(120deg);
			-ms-transform: rotate(120deg);
				transform: rotate(120deg);
	}

	.sk-circle .sk-circle6 {
		-webkit-transform: rotate(150deg);
			-ms-transform: rotate(150deg);
				transform: rotate(150deg);
	}

	.sk-circle .sk-circle7 {
		-webkit-transform: rotate(180deg);
			-ms-transform: rotate(180deg);
				transform: rotate(180deg);
	}

	.sk-circle .sk-circle8 {
		-webkit-transform: rotate(210deg);
			-ms-transform: rotate(210deg);
				transform: rotate(210deg);
	}

	.sk-circle .sk-circle9 {
		-webkit-transform: rotate(240deg);
			-ms-transform: rotate(240deg);
				transform: rotate(240deg);
	}

	.sk-circle .sk-circle10 {
		-webkit-transform: rotate(270deg);
			-ms-transform: rotate(270deg);
				transform: rotate(270deg);
	}

	.sk-circle .sk-circle11 {
		-webkit-transform: rotate(300deg);
			-ms-transform: rotate(300deg);
				transform: rotate(300deg);
	}

	.sk-circle .sk-circle12 {
		-webkit-transform: rotate(330deg);
			-ms-transform: rotate(330deg);
				transform: rotate(330deg);
	}

	.sk-circle .sk-circle2:before {
		-webkit-animation-delay: -1.1s;
				animation-delay: -1.1s;
	}

	.sk-circle .sk-circle3:before {
		-webkit-animation-delay: -1s;
				animation-delay: -1s;
	}

	.sk-circle .sk-circle4:before {
		-webkit-animation-delay: -0.9s;
				animation-delay: -0.9s;
	}

	.sk-circle .sk-circle5:before {
		-webkit-animation-delay: -0.8s;
				animation-delay: -0.8s;
	}

	.sk-circle .sk-circle6:before {
		-webkit-animation-delay: -0.7s;
				animation-delay: -0.7s;
	}

	.sk-circle .sk-circle7:before {
		-webkit-animation-delay: -0.6s;
				animation-delay: -0.6s;
	}

	.sk-circle .sk-circle8:before {
		-webkit-animation-delay: -0.5s;
				animation-delay: -0.5s;
	}

	.sk-circle .sk-circle9:before {
		-webkit-animation-delay: -0.4s;
				animation-delay: -0.4s;
	}

	.sk-circle .sk-circle10:before {
		-webkit-animation-delay: -0.3s;
				animation-delay: -0.3s;
	}

	.sk-circle .sk-circle11:before {
		-webkit-animation-delay: -0.2s;
				animation-delay: -0.2s;
	}

	.sk-circle .sk-circle12:before {
		-webkit-animation-delay: -0.1s;
				animation-delay: -0.1s;
	}

	@-webkit-keyframes sk-circleBounceDelay {
		0%, 80%, 100% {
			-webkit-transform: scale(0);
					transform: scale(0);
		} 40% {
			-webkit-transform: scale(1);
					transform: scale(1);
		}
	}

	@keyframes sk-circleBounceDelay {
		0%, 80%, 100% {
			-webkit-transform: scale(0);
					transform: scale(0);
		} 40% {
			-webkit-transform: scale(1);
					transform: scale(1);
		}
	}

	.sk-text {
    color: map-get($colors, white);
    font-size: 17px;
		font-weight: 700;
		position: absolute;
    top: 156px;
    width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator/form-step-three.vue